{
    "components": {
        "EstimateLineReader": {
            "linePerLoad": 10,
            "lineRemarkInput": {
                "min": 1,
                "max": 1530
            },
            "lineRemarkLimitedQuantity": 10,
            "class": {
                "error": "text-error-logo",
                "warning": "text-warning-logo",
                "info": "text-info-logo"
            }
        },
        "EstimateExporter": {
            "localStorageKey": "exportData"
        }
    },
    "global": {}
}